import "./App.css";
import { useState, useEffect } from "react";
import Scoreboard from "./component/Scoreboard";
import Gameboard from "./component/Gameboard";
import GameoverModal from "./component/GameoverModal";
import { GameModeProvider } from "./component/context/GameMode";
import { GameScoreProvider } from "./component/context/GameScore";

const App = () => {
  const [dimensions, setDimensions] = useState({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight,
  });

  const handleResize = () => {
    setDimensions({
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div
      className="top-container"
      style={(() => {
        var width = dimensions.w;
        var height = dimensions.h;
        var ratio = (height / width).toFixed(1);
        var scale;
        if (ratio <= 1.6) {
          scale = height / 900;
        } else {
          scale = width / 700;
        }
        return { transform: "scale(".concat(scale, ")") };
      })()}
    >
      <GameScoreProvider>
        <GameModeProvider>
          <Scoreboard />
          <Gameboard />
          <GameoverModal />
        </GameModeProvider>
      </GameScoreProvider>
    </div>
  );
};

export default App;
